import { render, staticRenderFns } from "./insertLabelDialog.vue?vue&type=template&id=659bc707"
import script from "./insertLabelDialog.vue?vue&type=script&lang=js"
export * from "./insertLabelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports